/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */
/* eslint-disable react/jsx-props-no-spreading */

import hljs from 'highlight.js/lib/core';
import bash from 'highlight.js/lib/languages/bash';
import ruby from 'highlight.js/lib/languages/ruby';
import python from 'highlight.js/lib/languages/python';
import php from 'highlight.js/lib/languages/php';
import java from 'highlight.js/lib/languages/java';
import javascript from 'highlight.js/lib/languages/javascript';
import go from 'highlight.js/lib/languages/go';
import swift from 'highlight.js/lib/languages/swift';
import c from 'highlight.js/lib/languages/c';
import csharp from 'highlight.js/lib/languages/csharp';
import xml from 'highlight.js/lib/languages/xml';

import React from 'react';
import classNames from 'classnames';
import { getHighlightClassForCodeLanguage } from 'utils/CodeViewerLanguageMapper';

hljs.registerLanguage('bash', bash);
hljs.registerLanguage('ruby', ruby);
hljs.registerLanguage('python', python);
hljs.registerLanguage('php', php);
hljs.registerLanguage('java', java);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('go', go);
hljs.registerLanguage('swift', swift);
hljs.registerLanguage('c', c);
hljs.registerLanguage('csharp', csharp);
hljs.registerLanguage('xml', xml);

function CodeViewerImpl({ children = '', codeLanguage = '', className, highlight = true, ...others }) {
  const selected = getHighlightClassForCodeLanguage(codeLanguage);

  let content = children;
  let highlightClass;
  if (highlight) {
    content = hljs.highlightAuto(children, selected ? [selected] : undefined).value;
    highlightClass = selected.toLowerCase();
    const domCount = (content.match(/hljs/g) || []).length;

    if (domCount >= 1500) {
      highlight = false;
    }
  }
  return (
    <pre>
      {highlight ? (
        <code
          data-testid="highlight"
          className={classNames(className, { [highlightClass]: selected }, 'hljs')}
          dangerouslySetInnerHTML={{ __html: content }}
          {...others}
        />
      ) : (
        <code data-testid="highlight" className={classNames(className)} {...others}>
          {children}
        </code>
      )}
    </pre>
  );
}

export default CodeViewerImpl;
